'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {DateHeader} from '../../../components/lists/DateHeader';
import {List} from '../../../components/lists/List';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {getItemClass} from '../../../core-utilities/redux';
import {SUB_HEADER} from '../../redux/peopleConfig';
import {PeopleItem} from '../PeopleItem';


export function PeopleListView(props) {
  return (
    <List
      className={classNames("PeopleList", props.className)}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {renderNullItem(props)}
      {props.list ? props.list.map(model => renderItem(props, model)) : null}
    </List>
  );
}

function renderNullItem(props) {
  if ((props.mode === ViewMode.SUCCESS || props.mode === ViewMode.NO_DATA) && props.useSelection && props.nullable) {
    return (
      <PeopleItem
        key="null"
        className={props.itemClassName}
        isSimple={props.useSimple}
        isSelected={props.selected === null}
        nullLabel={props.nullLabel}
        model={null}
        onClick={props.onClickNullItem}
      />
    );
  } else {
    return null;
  }
}

function renderItem(props, model) {
  if (model.type === SUB_HEADER) {
    // TODO: setup more generic header with i18n message support for PERSONNEL type
    return !props.useTypeHeaders ? null : (
      <DateHeader
        key={getId(model)}
        date={model.name}
      />
    );
  } else {
    const id = getId(model);
    return (
      <PeopleItem
        key={id}
        isSimple={props.useSimple}
        className={classNames(props.itemClassName, getItemClass(model))}
        isSelected={props.useSelection ? getId(props.selected) === id : false}
        model={model}
        onClick={props.onClickItem}
        onContextMenu={props.onItemContextMenu}
      />
    );
  }
}

PeopleListView.propTypes = {
  className: T.string,
  itemClassName: T.string,
  useTypeHeaders: T.bool,
  useSimple: T.bool,
  useSelection: T.bool,
  selected: T.object,
  nullable: T.bool,
  nullLabel: T.string,
  onClick: T.func,
  onClickNullItem: T.func,
  onClickItem: T.func,
  onItemContextMenu: T.func,
};

PeopleListView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleList/PeopleListView.js